// removed by extract-text-webpack-plugin
module.exports = {"bannerRow":"src-components-NewOpenedAccountBanner-___styles__bannerRow___3Yy0Y","bannerCol":"src-components-NewOpenedAccountBanner-___styles__bannerCol___2Stmf","mobile":"src-components-NewOpenedAccountBanner-___styles__mobile___2012P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewOpenedAccountBanner/styles.css
// module id = 869
// module chunks = 3